import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { FiMail, FiLinkedin, FiTwitter, FiGlobe } from 'react-icons/fi'

const Footer = () => {
  const { t } = useTranslation()
  const currentYear = new Date().getFullYear()

  return (
    <footer className="bg-slate-950 text-white relative z-10 border-t border-slate-900">
      <div className="container mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand Section */}
          <div className="md:col-span-1">
            <Link to="/" className="flex items-center space-x-3 mb-6 group">
              <img
                src="/JoyeeLOGO.jpg"
                alt="JoyeeAssets"
                className="h-12 w-12 rounded-xl shadow-lg transition-transform group-hover:scale-110"
              />
              <span className="text-2xl font-bold tracking-tight">久夷资产</span>
            </Link>
            <p className="text-slate-400 leading-relaxed mb-8">
              {t('footer.description')}
            </p>
            <div className="flex space-x-4">
              <a href="#" className="w-10 h-10 rounded-xl bg-slate-900 flex items-center justify-center text-slate-400 hover:bg-primary-600 hover:text-white transition-all">
                <FiTwitter />
              </a>
              <a href="#" className="w-10 h-10 rounded-xl bg-slate-900 flex items-center justify-center text-slate-400 hover:bg-primary-600 hover:text-white transition-all">
                <FiLinkedin />
              </a>
              <a href="mailto:rogercjd@joyeeassets.com" className="w-10 h-10 rounded-xl bg-slate-900 flex items-center justify-center text-slate-400 hover:bg-primary-600 hover:text-white transition-all">
                <FiMail />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-bold mb-6 text-lg">{t('footer.quickLinks')}</h3>
            <ul className="space-y-4">
              <li>
                <Link to="/" className="text-slate-400 hover:text-primary-500 transition-colors">
                  {t('nav.home')}
                </Link>
              </li>
              <li>
                <a href="#games" className="text-slate-400 hover:text-primary-500 transition-colors">
                  {t('nav.games')}
                </a>
              </li>
              <li>
                <a href="#about" className="text-slate-400 hover:text-primary-500 transition-colors">
                  {t('nav.about')}
                </a>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white font-bold mb-6 text-lg">{t('footer.services')}</h3>
            <ul className="space-y-4">
              <li className="text-slate-400 hover:text-slate-300 transition-colors cursor-default">
                {t('services.game_design.title')}
              </li>
              <li className="text-slate-400 hover:text-slate-300 transition-colors cursor-default">
                {t('services.game_dev.title')}
              </li>
              <li className="text-slate-400 hover:text-slate-300 transition-colors cursor-default">
                {t('services.launch.title')}
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-bold mb-6 text-lg">{t('footer.contact')}</h3>
            <ul className="space-y-4">
              <li className="flex items-center space-x-3 text-slate-400">
                <FiMail className="flex-shrink-0" />
                <a href="mailto:rogercjd@joyeeassets.com" className="hover:text-primary-500 transition-colors">
                  rogercjd@joyeeassets.com
                </a>
              </li>
              <li className="flex items-center space-x-3 text-slate-400">
                <FiGlobe className="flex-shrink-0" />
                <span>joyeeassets.com</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-900 mt-16 pt-8 flex flex-col md:flex-row justify-center items-center">
          <p className="text-slate-500 text-sm">
            {t('footer.copyright').replace('2025', currentYear.toString())}
          </p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
